export const FETCH_INVENTORY_COLORS_REQUEST = "FETCH_INVENTORY_COLORS_REQUEST";
export const FETCH_INVENTORY_COLORS_SUCCESS = "FETCH_INVENTORY_COLORS_SUCCESS";
export const FETCH_INVENTORY_COLORS_FAILURE = "FETCH_INVENTORY_COLORS_FAILURE";
